// src/components/screens/ClubList.tsx
import React, { useState, useEffect } from 'react';
import {  
  Container,
  Typography, 
  Box, 
  Grid, 
  CssBaseline, 
  Toolbar, 
  AppBar, 
  CircularProgress,
  Divider
} from '@mui/material';
import axios from 'axios';
import Logo from '../../../assets/images/logo_b.svg';
import { ThemeProvider } from '@mui/material/styles';
import DrawerMenu from '../Shared/DrawerMenu';
import { config } from '../../../config/settings.jsx';
import { getTheme } from '../../../config/theme';
import { api } from '../../../config/apis.jsx';
import { on } from 'events';


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  };
  const truncateAndCleanDescription = (description, maxLength) => {
    // Use regex to remove everything before the date and truncate to maxLength
    const cleanedDescription = description.replace(/^.*?\d{2}\/\d{2} /, '');
    if (cleanedDescription.length > maxLength) {
      return `${cleanedDescription.substring(0, maxLength)}...`;
    }
    return cleanedDescription;
  };

const History = () => {
  const cdrid = localStorage.getItem('cdrid');
  const [sortedRoundUphistory, setSortedRoundUpHistory] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [assetsPath, setAssetsPath] = useState('');
  const [subdomain, setSubdomain] = useState('');
  const [totalDebitAmount, setTotalDebitAmount] = useState(0);
  const [totalDebitLoading, setTotalDebitLoading] = useState(true);

// test

  useEffect(() => {
    const loadConfigAndAssets = async () => {
      setIsLoadingData(true);
      let subdomain;
  
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      if (parts.length > 2 && parts[1] === 'sipora' && parts[2] === 'io') {
        subdomain = parts[0];
        setSubdomain(subdomain);
      } else {
        subdomain = 'default';
      }
      localStorage.setItem('host', subdomain);
      console.log('subdomain:', subdomain)
      try {
        const settings = await import(`../../../config/${subdomain}/settings.jsx`);
        setAssetsPath(settings.logoURLDashboard);
      } catch (error) {
        console.error('Error loading theme and assets:', error);
      }
    };



      const getRoundUpHistory = async () => {
        setIsLoadingData(true);
      try {
        const response = await axios.post(
          api.retrieveHistory,
          { cdrid },
          { headers: { 'Content-Type': 'application/json',
        apikey: config.apikey,
            tenant: config.tenant
           } }
        );
        const roundUpHistory = sortDebitsByDate(response.data.roundUphistory);
        setSortedRoundUpHistory(roundUpHistory);
        console.log(response)
      }  catch (error) {
        console.error('failed to retrieve total payments', error);
      } finally {
        setIsLoadingData(false);
      }
    };

    const getTotalDebits = async () => {
      try {
        const response = await axios.post(
          api.debitsAllTime,
          { cdrid },
          {
            headers: {
              'Content-Type': 'application/json',
              apikey: config.apikey,
              tenant: config.tenant,
            },
          }
        );
  
        const totalDebits = response.data.debitAllTime;
        setTotalDebitAmount(totalDebits);
    
      } catch (error) {
        console.error('Failed to retrieve total payments', error);
      } finally {
        setTotalDebitLoading(false);
      }
    };
  
        

    if (cdrid) {
      loadConfigAndAssets();
      getRoundUpHistory();
      getTotalDebits();
  
    }
  }, [cdrid]);
 
  const sortDebitsByDate = (debits) => {
    return debits.sort((a, b) => {
      const aDate = new Date(a.createdDate);
      const bDate = new Date(b.createdDate);
      return bDate - aDate; // Sort in descending order
    });
  };

return (
    <ThemeProvider theme={getTheme}>
    <CssBaseline>
    <Container component="primary" maxWidth="xs"> 
    <AppBar position="static" color="appbar" elevation={0}>
          <Toolbar>
            <DrawerMenu />
            <Typography variant="body" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
              Round-Up History
            </Typography>
          </Toolbar>
        </AppBar></Container>
        <Container component="secondary" maxWidth="xs"> 

  
        <Grid item xs={12} justifyContent="center" height={3}>
    </Grid>
    <Box display="flex" flexDirection="column" alignItems="center" bgcolor="white" mt={2} p={2} borderRadius={4} >
        <Grid container justifyContent="center" mb={2}>
            <Grid item xs={12} justifyContent="center">
                <Box display="flex" justifyContent="center" >
                    <img src={assetsPath} alt="Logo"  style={{ width: '60%', height: 'auto'}} />
                </Box>

                <Box display="flex" alignItems="center" width="100%" marginTop="40px">
            <Box flexGrow={1}>
              <Divider />
            </Box>
            <Typography
              variant="body"
              sx={{ fontWeight: 'bold', mx: 2 }}
              gutterBottom
            >
             Total Donated To Date
            </Typography>
            <Box flexGrow={1}>
              <Divider />
            </Box>
          </Box>
          {isLoadingData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', mt: 1, mb: 1  }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography variant="h5" align="center" gutterBottom>
            ${((totalDebitAmount / 100).toFixed(2))}
          </Typography>
          </>)}

            </Grid>
        </Grid>
     
    </Box>


   

    


    <Box display="flex" flexDirection="column" alignItems="left" bgcolor="white" mt={2} p={2} borderRadius={4}>
  <Grid container alignItems="left">
    <Box display="flex" alignItems="left" width="100%" mt='10px'>
      <Grid item xs={2}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
          Date
        </Typography>
      </Grid>
      <Grid item xs={5}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'left', whiteSpace: 'nowrap' }}>
          Description
        </Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'right', whiteSpace: 'nowrap' }}>
          Amount
        </Typography>
      </Grid>
      <Grid item xs={2.5}>
        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold', textAlign: 'right', whiteSpace: 'nowrap' }}>
          Roundup
        </Typography>
      </Grid>
    </Box>
  </Grid>
  {isLoadingData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', mt: 5, mb: 5  }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
  
  {sortedRoundUphistory.map((debit, index) => (
    <Box key={index} display="flex" justifyContent="space-between" alignItems="center" width="100%" mt='10px'>
      <Typography variant="caption" sx={{ textAlign: 'left', flexGrow: 0, mr: 2, whiteSpace: 'nowrap' }}>
        {formatDate(debit.createdDate)}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'left', flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {truncateAndCleanDescription(debit.description, 50)}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'right', flexGrow: 0, whiteSpace: 'nowrap' }}>
        ${debit.amount}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'right', flexGrow: 0, ml: 2, color: 'darkgreen', whiteSpace: 'nowrap' }}>
        ${((debit.debitAmountCents / 100).toFixed(2))}
      </Typography>
    </Box>
  ))} </>)}
</Box>

    <Grid item xs={12} justifyContent="center" height={30}>
    </Grid>
    </Container>
            </CssBaseline>
            </ThemeProvider>
       
  );

}
export default History;

export {};